import * as faqsApi from '../api/faqs'
import { handleApiError } from './api-errors'

export const FETCH_FAQS = "FETCH_FAQS"
export const CREATE_FAQ = "CREATE_FAQ"
export const UPDATE_FAQ = "UPDATE_FAQ"
export const DELETE_FAQ = "DELETE_FAQ"

export const fetchFaqs = () => (dispatch) => {
    faqsApi.listObj().then(res => {
        dispatch({
            type: FETCH_FAQS,
            payload: res
        })
    }).catch(err => dispatch(handleApiError(err)))
}

export const createFaq = (question, answer) => (dispatch) => {
    faqsApi.putObj({
        question: question, answer: answer
    }).then(res => {
        dispatch({
            type: CREATE_FAQ,
            payload: res
        })
    })
    .then(dispatch(fetchFaqs()))
    .catch(err => dispatch(handleApiError(err)))
}

export const deleteFaq = (faq_id) => (dispatch) => {
    faqsApi.deleteObj(faq_id).then(res => {
        dispatch({
            type: DELETE_FAQ,
            payload: res
        })
    })
    .then(dispatch(fetchFaqs()))
    .catch(err => dispatch(handleApiError(err)))
}

export const updateFaq = (faq_id, question, answer) => (dispatch) => {
    faqsApi.patchObj(faq_id, {
        question: question, answer: answer
    }).then(res => {
        dispatch({
            type: UPDATE_FAQ,
            payload: res
        })
    })
    .then(dispatch(fetchFaqs()))
    .catch(err => dispatch(handleApiError(err)))
}
